import * as React from 'react';
import { Col, Row } from 'antd';

import { OfficeGeneralPartController } from './parts/officegeneral-part.controller';
import { OfficeContactPart } from './parts/officecontact-part';
import { ExtendedSchemaView } from 'src/core/ui/extended-schema.view';

interface OfficeFormViewProps extends ComponentViewProps<TransportCompanyOfficeItem> {
	title: string,
	mode: ControlMode;
	contextService: any;
	schema: JsonSchema;
}

export class OfficeFormView extends React.Component<OfficeFormViewProps, {}> {
	constructor(props: Readonly<OfficeFormViewProps>) {
		super(props);
	}

	private get hasExtendedProperties(): boolean {
		return this.props.schema.allOf != null && this.props.schema.allOf.length > 0 && Object.getOwnPropertyNames(this.props.schema.allOf[0].properties).length > 0;
	}

	render() {
		const office = this.props.model;

		return (
			<Row>
				<Col span={24}>
					<div className="card card-borderless">
						{
							office &&
							<OfficeGeneralPartController
								mode={this.props.mode}
								model={office}
								setBusy={this.props.setBusy}
							/>
						}
						{
							this.hasExtendedProperties &&
							<ExtendedSchemaView
								mode={this.props.mode}
								columns={2}
								model={this.props.model.dynamicProperties}
								schema={this.props.schema}
								setBusy={this.props.setBusy}
								title="Other Information"
							/>
						}
						{
							office &&
							<OfficeContactPart
								parentModel={office}
								mode={this.props.mode}
								model={office.dynamicProperties["contacts"]}
								setBusy={this.props.setBusy}
								contextService={this.props.contextService}
							/>
						}
					</div>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/office/office-form.view.tsx